import { cn } from '@/lib/utils'

// 一覧テーブル共通のクラス定数（発注照合テーブルの実装を切り出した共通部品）。
// text-left / text-right など列ごとに変わるものは呼び出し側で付与する
export const dataTableHeadRowClass = 'border-b border-border bg-muted'
export const dataTableThClass = 'px-4 py-3 font-semibold whitespace-nowrap text-muted-foreground'
export const dataTableTdClass = 'px-4 py-3'
// 「一覧＋詳細」の行で、その行を代表する名前列のセルを詳細へ誘導するリンクの見た目。
// 詳細ボタンを右端に置かず、名前列をリンクにする規約（docs/develop/client_ui/components/data-table.md「名前列のリンク」）の共通スタイル
export const dataTableLinkClass =
  'cursor-pointer rounded-sm text-primary hover:underline focus-visible:outline-2 focus-visible:outline-ring disabled:pointer-events-none disabled:opacity-50'
export const keyColumnShadowClass = 'shadow-[inset_-1px_0_0_var(--color-border)]'

export function dataTableRowClass(selected: boolean, highlighted = false) {
  return cn(
    'group border-b border-border transition-colors last:border-0',
    selected ? 'bg-accent' : highlighted ? 'bg-highlight-subtle' : 'hover:bg-secondary',
  )
}

// sticky セルは行の hover/選択色に追従させる必要がある。sticky 要素は独自の重なりコンテキストを持ち
// 親の背景色をそのまま透過しないため、選択中は bg-accent を固定で、非選択時は group-hover で
// 行の hover 色に追従させて色を合わせる。強調行（highlighted）は hover でも強調を保つ
export function stickyCellBgClass(selected: boolean, highlighted = false) {
  return selected ? 'bg-accent' : highlighted ? 'bg-highlight-subtle' : 'bg-card group-hover:bg-secondary'
}
